import React from 'react';
import classnames from 'classnames';
import s from './ThemeToggle.scss';
export default (function (_a) {
    var className = _a.className;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("label", { className: s['toggle'], htmlFor: "checkbox" },
            React.createElement("i", { className: s['star'] }),
            React.createElement("i", { className: s['star'] }),
            React.createElement("i", { className: s['star'] },
                React.createElement("span", { className: s['star-trail'] })),
            React.createElement("i", { className: s['star'] }),
            React.createElement("span", { className: s['disc'] },
                React.createElement("i", null)),
            React.createElement("span", { className: classnames(s['cloud'], s['cloud1']) }),
            React.createElement("span", { className: classnames(s['cloud'], s['cloud2']) }))));
});
//# sourceMappingURL=ThemeToggle.js.map